<template>
  <div>
    <b-card title="Notification Setting">
      <b-row>
        <b-col md="12">
          <b-form-group class="text-center" label="Drum Picking" label-for="drum-picking-toggle">
            <b-form-checkbox
              id="drum-picking-toggle"
              v-model="form.drumPicking"
              switch
            >ON</b-form-checkbox>
          </b-form-group>
        </b-col>
        <!-- <b-col md="6">
          <b-form-group label="Job Order" label-for="job-order-toggle">
            <b-form-checkbox
              id="job-order-toggle"
              v-model="form.jobOrder"
              switch
            >ON</b-form-checkbox>
          </b-form-group>
        </b-col> -->
      </b-row>
      <div class="text-right mt-4">
        <b-button variant="primary" @click="onSave" :disabled="loading">
          Simpan
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        drumPicking: false,
        jobOrder: false
      }
    }
  },
  methods: {
    onSave() {
      this.$store.dispatch('auth/updateNotifSetting', this.form).then(res => {
        this.$bvToast.toast("Success update data", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      }).catch(err => {
        console.error(err)
        this.$bvToast.toast("Error update data", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      })
    }
  },
  mounted() {
    this.$store.dispatch('auth/fetchNotifSetting').then(res => {
      this.form.drumPicking = res.drumPicking;
      this.form.jobOrder = res.jobOrder
    }).catch(err => {
      console.error(err)
      this.$bvToast.toast("Error get data", {
        title: "Error",
        variant: "danger",
        solid: true,
      });
    })
  },
}
</script>